import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { AuthenticationService } from './services/authentication.service';


@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
})
export class AuthenticationComponent implements OnInit {
  public form: FormGroup = Object.create({});
  public msg = '';

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    private _location: Location,
    private _authService: AuthenticationService
  ) {}

  ngOnInit() {

    if (this._authService.getAuthToken()) {
      this._authService.verifyToken({token: this._authService.getAuthToken()}).subscribe((validate) => {
        console.log("VALIDADTE", validate)
        if (validate && validate.body) {
          this._authService.setToken(validate.body.token, true);
          this._router.navigate(['/admin'])
        }
      })
    }
   
    this.intializeForms()
  
  }


  intializeForms() {
    this.form = this._fb.group({
      uname: [null, Validators.compose([Validators.required])],
      password: [null, Validators.compose([Validators.required])],
      remember:[false]
    });
  }

  onSubmit() {
    const uname = this.form.value.uname;
    const pwd = this.form.value.password;
    const rnb = this.form.value.remember;

    this._authService.singIn({username:uname, password:pwd}).subscribe((res) => {
      if (res && res.status) {
        let token = res.body.token;
        this._authService.setToken(token, rnb);
        this._router.navigate(['/admin']);
      }
    })
  }

}
